<script>
import Layout from '@layouts/primary'
import { siteMethods } from '@state/helpers'
import { rrulestr } from 'rrule'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'ViewSite',
    meta: [{ name: 'description', content: 'ViewSite' }],
  },
  components: { Layout },
  data() {
    return {
      site: {},
      editSite: false,
      removeSite:false,
      dictionary: {
        attributes: {
          email: 'E-mail Address',
          // custom attributes
        },
        custom: {
          name: {
            required: () => 'Name can not be empty',
            max: 'The name field may not be greater than 10 characters',
            // custom messages
          },
          select: {
            required: 'Select field is required',
          },
        },
      },
      isSafeToDelete: false,
    }
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
    let that  = this;
    let cid = this.$router.history.current.params.id
    this.isSafeToDelete = this.$router.history.current.params.isSafeToDelete
    this.siteById({id: cid}).then(response => {
      that.site = this.$store.state.sites.currentSite
      that.site.value = true

      // In order to dont mutate state obj, create a "copy of it"
      let formattedObj = {
        ...that.site
      }

      that.site = formattedObj
    })
  },
  methods: {
    ...siteMethods,
    async update() {
      await this.$validator.validateAll().then((response) => {
        // console.log(response)
        if(response){
          this.site.id = parseInt(this.site.id)
          this.site.postcode = parseInt(this.site.postcode)
          this.updateSite(this.site).then(d => {
            location.reload()
          })
          this.editSite = !this.editSite
        }
      })
    },
    submit() {
      this.site.id = parseInt( this.site.id )
      // Deleting only if a site is safe to delete
      if( this.isSafeToDelete ) {
        this.deleteSite( this.site ).then( d => {
          this.$router.push('/admin/client-center')
          location.reload()
          // this.$router.go(-1)
        })
      }
    },
    changeRoute(r) {
      this.$router.push(r)
    },
    rulify(s) {
      if (s) {
        return rrulestr(s).toText().toUpperCase();
      }
      else
        return "No Schedule"
    },
  }
}
</script>

<template>
  <Layout>
    <VContainer grid-list-md>
      <h2>View Location</h2>
      <VCard class="v-card-padding top-blue">
        <VLayout>
          <VFlex style="padding: 15px;">
            <h3 class="fixedSpaceVertical">
              {{ site.trading_name }}
            </h3>
            <p>
              <i class="fas fa-user fixedSpaceHorizontal" /> {{ site.contact_name }}
            </p>
            <p>
              <i class="fas fa-map-marker fixedSpaceHorizontal" /> {{ site.address }}, {{ site.suburb }} {{ site.postcode }}
            </p>
            <p> <i class="fas fa-globe-asia fixedSpaceHorizontal" /> {{ site.state }},  {{ site.country }} </p>

            <p> <i class="fas fa-phone fixedSpaceHorizontal" /> {{ site.phone }}</p>
            <p> <i class="fas fa-mobile-alt fixedSpaceHorizontal" /> {{ site.mobile }}</p>
            <p> <i class="fas fa-envelope fixedSpaceHorizontal" /> {{ site.email }}</p>
          </VFLEX>
        </VLayout>
        <VSpacer />

        <VLayout
          row
          wrap
        >
          <VFlex
            xs12
            sm3
            style="padding: 15px 15px 0 15px"
            ;
          >
            <VBtn
              color="blue"
              block
              outline

              @click.native="editSite = !editSite"
            >
              EDIT
            </VBtn>
          </VFlex>
          <VFlex
            xs12
            sm3
            style="padding: 15px;"
          >
            <VBtn
              v-if="this.$store.getters['auth/getUserRole'] == 'Admin' && isSafeToDelete"
              color="orange"
              block
              @click.native="removeSite = !removeSite"
            >
              Delete
            </VBtn>
            <VBtn
              v-else
              color="orange"
              block
              disabled
            >
              Delete
            </VBtn>
          </VFlex>
        </VLayout>
        <!-- Note for why a site can't be deleted -->
        <VLayout
          row
          wrap
        >
          <VFlex
            v-if="!isSafeToDelete"
            xs12
            sm9
            style="padding: 15px 15px 0 15px"
          >
            <span style="color: red">
              Note: This site can't be deleted because it has Service Agreements.
            </span>
          </VFlex>
        </VLayout>
      </VCard>

      <VLayout
        row
        justify-center
      >
        <VDialog
          v-model="removeSite"
          persistent
          max-width="500px"
          scrollable
        >
          <VCard>
            <VCardText>
              <VContainer grid-list-md>
                <h2>Are you sure you want to delete {{ site.username }}?</h2>
                <VLayout wrap>
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="blue"
                      block
                      outline
                      @click.native="removeSite = !removeSite"
                    >
                      Close
                    </VBtn>
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="orange"
                      block
                      @click.native="submit()"
                    >
                      DELETE
                    </VBtn>
                  </VFlex>
                </VLayout>
              </VContainer>
            </VCardText>
          </VCard>
        </VDialog>
      </VLayout>

      <!-- Update Location Card-->
      <VLayout
        row
        justify-center
      >
        <VDialog
          v-model="editSite"
          persistent
          max-width="500px"
          scrollable
        >
          <VCard>
            <VCardText>
              <VContainer grid-list-md>
                <h2>Edit Location:</h2>
                <VLayout wrap>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="site.address"
                      v-validate="'required'"
                      :error-messages="errors.collect('address')"
                      label="Address"
                      data-vv-name="address"
                      required
                    />
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="site.suburb"
                      v-validate="'required'"
                      :error-messages="errors.collect('suburb')"
                      label="Suburb"
                      data-vv-name="suburb"
                      required
                    />
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="site.state"
                      v-validate="'required'"
                      :error-messages="errors.collect('state')"
                      label="State"
                      data-vv-name="state"
                      required
                    />
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="site.country"
                      v-validate="'required'"
                      :error-messages="errors.collect('country')"
                      label="Country"
                      data-vv-name="country"
                      required
                    />
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="site.postcode"
                      v-validate="'required'"
                      :error-messages="errors.collect('postcode')"
                      label="Postcode"
                      data-vv-name="postcode"
                      required
                    />
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="site.phone"
                      v-validate="'required'"
                      :error-messages="errors.collect('phone')"
                      label="Phone"
                      data-vv-name="phone"
                      required
                    />
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="site.mobile"
                      v-validate="'required'"
                      :error-messages="errors.collect('mobile')"
                      label="Mobile"
                      data-vv-name="mobile"
                      required
                    />
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="site.contact_name"
                      v-validate="'required'"
                      :error-messages="errors.collect('contact_name')"
                      label="Contact Name"
                      data-vv-name="contact_name"
                      required
                    />
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="site.email"
                      v-validate="'required|email'"
                      :error-messages="errors.collect('email')"
                      label="Email"
                      data-vv-name="email"
                      required
                    />
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="site.trading_name"
                      v-validate="'required'"
                      :error-messages="errors.collect('trading name')"
                      label="Trading Name"
                      data-vv-name="trading name"
                      required
                    />
                  </VFlex>

                  <VSpacer />

                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="blue"
                      block
                      outline
                      @click.native="editSite = !editSite"
                    >
                      Close
                    </VBtn>
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="blue"
                      block
                      @click.native="update()"
                    >
                      Save
                    </VBtn>
                  </VFlex>
                </VLayout>
              </VContainer>
            </VCardText>
          </VCard>
        </VDialog>
      </VLayout>
    </VContainer>
  </Layout>
</template>

<style lang="scss" module>
    @import '@design';
</style>
